import * as React from 'react';
import { animate } from 'motion';

import { Ball, BOUNCE_MAGNITUDE } from './CssVsJs.helpers';

interface Props {
  isPlaying: boolean;
}

function BallMotion({ isPlaying }: Props) {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isPlaying) {
      return;
    }

    const { stop } = animate(
      ref.current!,
      {
        transform: `translateX(${BOUNCE_MAGNITUDE}px)`,
      },
      {
        duration: 1,
        ease: 'linear',
        repeat: Infinity,
        repeatType: 'reverse',
      }
    );

    return () => {
      stop();
    };
  }, [isPlaying]);

  return <Ball ref={ref} />;
}

export default BallMotion;
